/** Deterministic 20% holdout for the feature-aware paywall experiment (#131).
 * The holdout sees the legacy generic Popup; everyone else sees the new modal.
 * djb2 over the userId keeps assignment stable across sessions and devices. */
export const PAYWALL_HOLDOUT_PCT = 20;

export function isInPaywallHoldout(userId: string | undefined | null): boolean {
  if (!userId) return false; // fail open: unknown user sees the new modal
  let h = 5381;
  for (let i = 0; i < userId.length; i++) h = ((h << 5) + h + userId.charCodeAt(i)) | 0;
  return Math.abs(h) % 100 < PAYWALL_HOLDOUT_PCT;
}
